import { api } from './api.js';
import { TAG_NOTIFICATIONS } from './tags.js';

export const notificationsEndpoints = api.injectEndpoints({
    endpoints: (builder) => ({
        getNotifications: builder.query({
            query: ({ status, page, per_page, filter, time } = {}) => {
                const queryParams = new URLSearchParams();
                if (status) queryParams.append('status', status);
                if (page) queryParams.append('page', page);
                if (per_page) queryParams.append('per_page', per_page);
                if (filter) queryParams.append('filter', filter);
                if (time) queryParams.append('time', time);

                return {
                    url: `/notifications?${queryParams.toString()}`,
                    method: 'GET'
                };
            },
            providesTags: [TAG_NOTIFICATIONS],
            async onQueryStarted(_, { queryFulfilled }) {
                await queryFulfilled;
            }
        }),
        markNotification: builder.mutation({
            query: (data) => ({
                url: `/notifications/mark`,
                method: 'POST',
                body: data,
                toast: false
            }),
            invalidatesTags: [TAG_NOTIFICATIONS],
            async onQueryStarted(_, { queryFulfilled }) {
                await queryFulfilled;
            }
        }),
        getNotificationsTypes: builder.query({
            query: () => ({
                url: '/misc/notification-types',
                method: 'GET'
            }),
            async onQueryStarted(_, { queryFulfilled }) {
                await queryFulfilled;
            }
        }),
        massDeleteNotifications: builder.mutation({
            query: (data) => ({
                url: `/notifications/bulk-delete`,
                method: 'POST',
                body: data
            }),
            invalidatesTags: [TAG_NOTIFICATIONS],
            async onQueryStarted(_, { queryFulfilled }) {
                await queryFulfilled;
            }
        })
    })
});

export const {
    useLazyGetNotificationsQuery,
    useMarkNotificationMutation,
    useGetNotificationsTypesQuery,
    useMassDeleteNotificationsMutation
} = notificationsEndpoints;
